import { Vector3 } from "three";

export interface BoneLengths {
  [key: string]: number;
}

export class JointPositions {
  points: { [key: string]: Vector3 } = {};

  centralise(rootName: string) {
    if (!this.points.hasOwnProperty(rootName)) {
      console.warn(`no root "${rootName}" available to centralise`);
      return;
    }
    const rootPos = this.points[rootName].clone();
    for (const name in this.points) {
      const point = this.points[name];
      point.set(point.x - rootPos.x, point.y, point.z - rootPos.z);
    }
  }

  get(name: string): Vector3 | undefined {
    return this.points[name];
  }

  set(name: string, value: Vector3) {
    if (this.points[name]) {
      this.points[name].copy(value);
    } else {
      this.points[name] = value;
    }
  }

  clear() {
    this.points = {};
  }
}

export interface Axes {
  pos: Vector3;
  fwd: Vector3;
  up: Vector3;
  right: Vector3;
}
